import { createContext, useContext, type ReactNode } from "react";
import type { CatalogData } from "@/services/catalog";

const CatalogContext = createContext<CatalogData | null>(null);

export function CatalogProvider({
  value,
  children
}: {
  value: CatalogData;
  children: ReactNode;
}): JSX.Element {
  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
}

export function useCatalog(): CatalogData {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error("useCatalog must be used within a CatalogProvider");
  }
  return context;
}
